// @mui
import { Stack, Typography } from '@mui/material';
// auth
// layouts
import LoginLayout from '@raas/shared/src/layouts/login';
//
import { useLocales } from '@raas/shared/src/locales';
import { APP_REGISTRATION_CLIENT_ID } from '@raas/shared/src/shared-config-global';
import AuthLoginForm from './AuthLoginForm';
// ----------------------------------------------------------------------

interface LoginProps {
  requiredPermission: string;
}

export default function Login(props: LoginProps) {
  const { translate } = useLocales();
  const { requiredPermission } = props;

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">{translate('common.signIn')}</Typography>
      </Stack>
      <AuthLoginForm
        requiredPermission={requiredPermission}
        clientId={APP_REGISTRATION_CLIENT_ID}
      />
    </LoginLayout>
  );
}
